import { FC, ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { LoyaltyType } from '../../../../../../../../graphql/promotions/models/get-promotions.models';
import {
  FIRST_WELCOME_VOUCHER_VALUE,
  SECOND_WELCOME_VOUCHER_VALUE,
} from '../../../../../../../../constants';
import { useStyles } from './promotions.styles';
import { IBonus } from '../../../../../../../../graphql/bonuses/models/get-bonuses.models';


export const Promotions: FC<{ voucherByAuthId: IBonus[] }> = ({ voucherByAuthId }) => {
  const classes = useStyles();
  const intl = useIntl();
  const promotionsAmount = voucherByAuthId.length;

  const isFirstVoucher = voucherByAuthId.length === 1
    && voucherByAuthId[0].name === LoyaltyType.discountFirstPurchase;
  const isSecondVoucher = voucherByAuthId.length === 1
    && voucherByAuthId[0].name === LoyaltyType.discountSecondPurchase;
  const isWelcomeVouchers = isFirstVoucher || isSecondVoucher;

  const firstVoucherValue = FIRST_WELCOME_VOUCHER_VALUE + SECOND_WELCOME_VOUCHER_VALUE;

  const WelcomeAmount = () => (
    <>
      {intl.formatMessage(
        { id: 'myPointsPreview.bonuses.promotions.amount' },
        {
          value: isFirstVoucher ? firstVoucherValue : SECOND_WELCOME_VOUCHER_VALUE,
          span: (chunks: ReactNode) => (
            <span
              className={classes.emphasis}
              data-testid="emphasis"
            >
              {chunks}
            </span>
          ),
        },
      )}
    </>
  );

  return (
    <FormattedMessage
      id="myPointsPreview.bonuses.promotions"
      values={{ amount: isWelcomeVouchers ? <WelcomeAmount /> : promotionsAmount }}
    />
  );
};
